import Vue from "vue";
import Router from "vue-router";
import global from "../assets/js/global";

//login

import Login from "../pages/Login/login";
import LoginModel from "../pages/Login/login-model";
import userAgreement from "../pages/Login/userAgreement";
import privacy from "../pages/Login/privacy";

//tabbar
import Home from "../pages/Home/home";
import create from "../pages/Create/create";
import article from "../pages/Create/article";
import specific from "../pages/Specific/specific";
import Mine from "../pages/Mine/mine";


//Home

import setting from "../pages/Home/setting";
import test from "../pages/Home/test";
import coupon from "../pages/Home/coupon";
import About from "../pages/Home/about";
import userInfo from "../pages/Home/userinfo";
import subscribe from "../pages/Home/subscribe";
import articleDetail from "../pages/Create/articleDetail";
import createDetail from "../pages/Create/createDetail";

// Expert

import Invite from "../pages/Invite";


//Mine

import Mineinvite from "../pages/Mine/Invite";
import Cooperate from "../pages/Mine/cooperate";
import chat from "../pages/Mine/chat";
import Consume from "../pages/Mine/consume";
import User from "../pages/Mine/user";
import mychat from "../pages/Mine/mychat";
import report from "../pages/Mine/report";
import mychat1 from "../pages/Mine/mychat1";

import store from "../store/index.js";

let redirectUrl = "";
if (global.isApp) {
  redirectUrl = "/home";
} else {
  if (localStorage.getItem("token")) {
    redirectUrl = "/home";
  } else {
    redirectUrl = "/login";
  }
}

Vue.use(Router);

// ======解决路由跳转报错======
const originalPush = Router.prototype.push;
Router.prototype.push = function push (location, onResolve, onReject) {
  store.commit("changeIsBack", false);
  store.commit("isReplace", false);
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace (location, onResolve, onReject) {
  store.commit("isReplace", true);
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch((err) => err);
};
// ======解决路由跳转报错======

Router.prototype.goBack = function (index) {
  store.commit("changeIsBack", true);
  store.commit("isReplace", false);
  // this.go(-1);
  console.log("返回", window.history);
  let i = index || -1
  try {
    setTimeout(() => {
      this.back(index);
      console.log("返回1");
    }, 1);
    return false;
  } catch (e) {
    console.log("返回2", e);
  }
};
let base = process.env.BASE_URL.includes('DQETPJXXZT') ? '/DQETPJXXZT/' : '/'
const router = new Router({
  scrollBehavior: (to, from, savePosition) => {
    if (savePosition) {
      return savePosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  mode: "history",
  base: base,
  routes: [
    {
      path: "/",
      redirect: redirectUrl,
    },
    {
      path: "/login",
      name: "login",
      meta: {
        keepAlive: false
      },
      component: Login,
    },
    {
      path: "/login-model",
      name: "login-model",
      component: LoginModel,
    },
    {
      path: "/userAgreement",
      name: "userAgreement",
      component: userAgreement,
    },
    {
      path: "/privacy",
      name: "privacy",
      component: privacy,
    },
    {
      path: "/home",
      name: "home",
      component: Home,
      meta: {
        keepAlive: true,
        inds: 0,
      },
    },
    {
      path: "/test-box",
      name: "test-box",
      component: test,
    },
    {
      path: "/user-info",
      name: "user-info",
      component: userInfo,
    },
    {
      path: "/about",
      name: "about",
      component: About,
    },
    {
      path: "/create",
      name: "create",
      component: create,
      meta: {
        keepAlive: true,
        inds: 2,
      },
    },
    {
      path: "/article",
      name: "article",
      component: article,
    },
    {
      path: "/articleDetail",
      name: "articleDetail",
      component: articleDetail,
    },
    {
      path: "/specific",
      name: "specific",
      component: specific,
      meta: {
        keepAlive: true,
        inds: 1,
      },
    },
    {
      path: "/mine",
      name: "mine",
      component: Mine,
      meta: {
        keepAlive: true,
        inds: 3,
      },
    },
    {
      path: "/chat",
      name: "chat",
      component: chat,
    },
    {
      path: "/mine/invite",
      name: "mine-invite",
      component: Mineinvite
    },
    {
      path: "/mine/report",
      name: "mine-report",
      component: report
    },
    {
      path: "/mine/cooperate",
      name: "mine-cooperate",
      component: Cooperate
    },
    {
      path: "/mine/consume",
      name: "mine-consume",
      component: Consume
    },
    {
      path: "/invite/user",
      name: "invite-user",
      component: User
    },
    {
      path: "/invite",
      name: "invite",
      component: Invite,
      // meta: {
      //   keepAlive: true,
      //   inds: 2
      // }
    },
    {
      path: "/mychat",
      name: "mychat",
      component: mychat,
    },
    {
      path: "/mychat1",
      name: "mychat1",
      component: mychat1,
    },
    {
      path: "/setting",
      name: "setting",
      component: setting,
    },
    {
      path: "/subscribe",
      name: "subscribe",
      meta: {
        keepAlive: true
      },
      component: subscribe,
    },
    {
      path: "/coupon",
      name: "coupon",
      component: coupon,
    },
    {
      path: "/createDetail",
      name: "createDetail",
      component: createDetail,
      meta: {
        keepAlive: false
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (
    to.name !== "login" &&
    to.name !== "login-model" &&
    to.name !== "userAgreement" &&
    to.name !== "privacy" &&
    to.name !== "test-box"
  ) {
    let token = localStorage.getItem("token");
    if (!token) {
      if (to.query.inviteCode) {
        console.log("before inviteCode", to.query.inviteCode);
        localStorage.setItem("inviteCode", to.query.inviteCode);
      }
      router.replace({
        path: "/login",
        query: {
          inviteCode: to.query.inviteCode,
        },
      });
    } else {
      next();
    }
  } else {
    next();
  }
  // next()
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js